// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__zGe+Z"};